import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

import { t } from 'ember-intl';
import { isEmpty, not } from 'ember-truth-helpers';

import Preview from 'umg-ember-backend/components/record-explorer/for/mlp/templates/preview/index';
import Button from 'umg-ember-backend/components/ui/button/index';
import Window from 'umg-ember-backend/components/ui/window/index';
import { getBem } from 'umg-ember-backend/utils/get-bem';

import styles from './styles.module.css';

const bem = getBem(styles);

export default class RecordExplorerForMlpTemplateComponent extends Component {
  // Defaults
  @tracked selectedTemplate = null;

  // Actions
  selectTemplate = (template) => {
    if (this.selectedTemplate === template) {
      this.selectedTemplate = null;
    } else {
      this.selectedTemplate = template;
    }
  };

  // Template
  <template>
    <Window @isLoading={{isEmpty @templates}}>
      <:title>
        {{t 'record_explorer.for.mlp.templates.title'}}
      </:title>

      <:description>
        {{t 'record_explorer.for.mlp.templates.description'}}
      </:description>

      <:body>
        <div class={{(bem)}}>
          {{#each @templates as |template|}}
            <Preview
              @previewTemplate={{@previewTemplate}}
              @template={{template}}
              @selectedTemplate={{this.selectedTemplate}}
              @selectTemplate={{this.selectTemplate}}
            />
          {{/each}}
        </div>
      </:body>

      <:bottombar>
        <Button
          @style='outline'
          @label={{t 'record_explorer.for.mlp.templates.add_blank'}}
          {{on 'click' @addRecord}}
        />

        <Button
          @disabled={{not this.selectedTemplate}}
          @label={{t 'record_explorer.for.mlp.templates.add_from_template'}}
          {{on 'click' (fn @addFromTemplate this.selectedTemplate)}}
        />
      </:bottombar>
    </Window>
  </template>
}
